import React, { useEffect } from 'react';
import { CompanyLogoOnboarding as View } from '@views';
import { trackEvent } from '@utils/mixpanel';
import { useLocation } from 'react-router-dom';

const CompanyLogoOnboarding = () => {
  const location = useLocation();

  useEffect(() => {
    const pageTitle = 'Mindspace: Company Logo';
    document.title = pageTitle;

    window.gtag('event', 'page_view', {
      page_title: pageTitle,
    });

    trackEvent('Page Viewed', {
      Page: 'Company Logo - Onboarding',
    });
  }, []);

  return <View direction={location?.state?.direction} />;
};

export default CompanyLogoOnboarding;
